/**
 * AssetChatUserEvents
 * Registry of events for the AI asset chat surfaces (GlobalChatDock, AssetChat)
 */
export enum AssetChatUserEvents {
    OpenFeedbackPopover = "Asset Chat - Open Feedback Popover",
    SubmitFeedback = "Asset Chat - Submit Feedback",
    SendMessage = "Asset Chat - Send Message",
    StopGeneration = "Asset Chat - Stop Generation",
    ResponseError = "Asset Chat - Response Error",
}
